import('./pb23-concept--line.css');
const pb23ConceptLine = {
    init() {
        $('.pb23-concept--line').find('.jsExpand').on('click',function(){
            console.log("OK");
            $(this).closest('.content--wrapper').toggleClass("expanded",1000);
            return false;
        });
	}
}

window.initializeComponent.push({ component: "pb23-concept--line", init: pb23ConceptLine.init });

export default() => {
    pb23ConceptLine.init();
}